export interface BusinessInvoicesFilterParams {
  startDate?: string | null;
  endDate?: string | null;
  folio?: string;
  stakeholderIdentifier?: string;
  stakeholderName?: string;
  businessName?: string;
}

export const buildBusinessInvoicesQuery = (
  filters: BusinessInvoicesFilterParams,
  pagination: { page: number; pageSize: number },
): string => {
  const params = new URLSearchParams();
  if (filters.startDate) params.set('startDate', filters.startDate);
  if (filters.endDate) params.set('endDate', filters.endDate);
  if (filters.stakeholderIdentifier)
    params.set('stakeholderIdentifier', filters.stakeholderIdentifier);
  if (filters.stakeholderName)
    params.set('stakeholderName', filters.stakeholderName);
  if (filters.businessName) params.set('businessName', filters.businessName);
  if (filters.folio) params.set('folio', filters.folio);
  params.set('page', String(pagination.page));
  params.set('pageSize', String(pagination.pageSize));
  return params.toString();
};
